export const DEFAULT_REVALIDATE_TIME = 10 * 60; // 10 minutes
export const CUSTOM_CATEGORY_REVALIDATE_TIME = 10; // 10 seconds
